import React, { useState } from 'react';
import styles from './EasterEggModal.module.scss';
import LectureModal from './LectureModal';

const EasterEggModal = ({ onClose }) => {
  const [showLectureModal, setShowLectureModal] = useState(false);
  const [showDottedModal, setShowDottedModal] = useState(false);
  const [showPracticeModal, setShowPracticeModal] = useState(false);
  const [showRepoModal, setShowRepoModal] = useState(false);
  const [showSecurityModal, setShowSecurityModal] = useState(false);

  const copyCode = (code) => {
    // 인코딩을 명시적으로 UTF-8로 처리
    const textBlob = new Blob([code], { type: 'text/plain;charset=utf-8' });
    const clipboardItem = new ClipboardItem({
      'text/plain': textBlob
    });
    
    navigator.clipboard.write([clipboardItem]).then(() => {
      alert('코드가 클립보드에 복사되었습니다!');
    }).catch(() => {
      // fallback: 기존 방식 사용
      navigator.clipboard.writeText(code);
      alert('코드가 클립보드에 복사되었습니다!');
    });
  };

  const downloadLifeGraph = () => {
    const link = document.createElement('a');
    link.href = '/lecture/life_graph_jpg.zip';
    link.download = 'life_graph_jpg.zip';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadAutoDeployFiles = () => {
    const files = [
      {
        path: '/lecture/firebase-hosting-pull-request.yml',
        name: 'firebase-hosting-pull-request.yml',
      },
      {
        path: '/lecture/firebase-hosting-merge.yml',
        name: 'firebase-hosting-merge.yml',
      },
    ];

    files.forEach(({ path, name }) => {
      const link = document.createElement('a');
      link.href = path;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const practiceText = `(1)은 흘러가도 (2)은 남는다.
봄이 가고 여름이 와도, 인간의 (3)은 그 자리에 머문다.
(4)은 그렇게 흘러가며, (5)은 또 다른 시작을 품는다.
- (6) 중에서

1. 세월
2. 삶의 흔적
3. 슬픔과 기쁨
4. 시간
5. 땅
6. 토지`;

  return (
    <>
      <div className={styles.modalOverlay}>
        <div className={styles.modalContent}>
          <h2>🎉 축하합니다! 🎉</h2>
          <div className={styles.message}>
            <p>이스터에그를 발견하셨군요!</p>
            <p>이 사이트는 여러분의 즐거움을 위해 만들어졌습니다.</p>
            <p>앞으로도 더 많은 게임과 이스터에그가 추가될 예정이니 기대해주세요!</p>
            <p>감사합니다. 즐거운 하루 되세요! 😊</p>
          </div>
          <div className={styles.buttonContainer}>
            <button 
              className={styles.lectureButton}
              onClick={() => setShowLectureModal(true)}
            >
              도트매트릭스 강의자료
            </button>
            <button 
              className={styles.lectureButton}
              onClick={() => setShowDottedModal(true)}
            >
              점선면 강의자료
            </button>
            <button className={styles.closeButton} onClick={onClose}>
              닫기
            </button>
          </div>
        </div>
      </div>

      {showLectureModal && (
        <LectureModal onClose={() => setShowLectureModal(false)} />
      )}

      {showDottedModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <h2>점선면 강의자료</h2>
            <div className={styles.section}>
              <div className={`${styles.buttonContainer} ${styles.twoRows}`}>
                <div className={styles.buttonRow}>
                  <button 
                    className={styles.lectureButton} 
                    onClick={() => setShowPracticeModal(true)}
                  >
                    복사하기 연습하기
                  </button>
                  <button 
                    className={styles.lectureButton} 
                    onClick={downloadLifeGraph}
                  >
                    인생그래프 이미지 다운
                  </button>
                </div>
                <div className={styles.buttonRow}>
                  <button 
                    className={styles.lectureButton} 
                    onClick={() => setShowRepoModal(true)}
                  >
                    레포지토리 주소 복사
                  </button>
                  <button 
                    className={styles.lectureButton} 
                    onClick={() => setShowSecurityModal(true)}
                  >
                    보안정책 명령어
                  </button>
                </div>
                <div className={styles.buttonRow}>
                  <button 
                    className={styles.lectureButton} 
                    onClick={downloadAutoDeployFiles}
                  >
                    점선면 강의자료 자동배포 파일
                  </button>
                  <button className={styles.closeButton} onClick={() => setShowDottedModal(false)}>
                    닫기
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showPracticeModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <h2>복사하기, 붙여넣기 연습하기</h2>
            <div className={styles.codeContainer}>
              <pre className={styles.code}>{practiceText}</pre>
            </div>
            <div className={styles.buttonContainer}>
              <button className={styles.closeButton} onClick={() => setShowPracticeModal(false)}>
                닫기
              </button>
            </div>
          </div>
        </div>
      )}

      {showRepoModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <h2>레포지토리 주소</h2>
            <div className={styles.section}>
              <div className={styles.codeContainer}>
                <pre className={styles.code}>https://github.com/heokiro/my-story-exhibit.git</pre>
              </div>
              <div className={styles.buttonContainer}>
                <button className={styles.closeButton} onClick={() => setShowRepoModal(false)}>
                  닫기
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSecurityModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <h2>보안정책 명령어</h2>
            <div className={styles.section}>
              <div className={styles.codeContainer}>
                <pre className={styles.code}>Set-ExecutionPolicy -Scope CurrentUser RemoteSigned -Force</pre>
              </div>
              <div className={styles.buttonContainer}>
                <button className={styles.closeButton} onClick={() => setShowSecurityModal(false)}>
                  닫기
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EasterEggModal; 